define('drops/dynamicVideo/dynamicVideo',[
    'jquery',
    'lq/drop',
    'lq/util',
    'lq/style',
    'lq/videoPlayer',
    'lq'
], function ($, Drop, util, Style, VideoPlayer, lq) {
    'use strict';

    var defaults = {
        data: {
            value: '',
            loop: false,
            controls: true
        }
    };

    function DynamicVideo(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.url = null;

        if (this.data.size.x < 200)
            this.data.size.x = 200;
        if (this.data.size.y < 100)
            this.data.size.y = 100;

        this.$element
            .addClass('boxToBorderSize');

        Style.renderStyles(this);
    };

    Drop.extend(DynamicVideo, Drop);

    DynamicVideo.typeName = 'DynamicVideo';

    DynamicVideo.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    DynamicVideo.prototype.setValue = function (update) {
        var value = util.convertListOfKeyValuesToObject(update.value);
        var url = value.url || value.Url;

        if (url && url.length > 0)
            this.url = lq.getTenantUrl('DynamicContent/File/' + url);
        else if(update.value)
            this.url = update.value;

        if(this.isVisible())
            this.openVideoPlayer();
    };

    DynamicVideo.prototype.openVideoPlayer = function () {
        if (!this.player)
            this.player = new VideoPlayer(this.$element);

        var config = {
            url: this.url,
            autoPlay: this.data.autoPlay,
            poster: this.data.poster,
            loop: this.data.loop,
            controls: this.data.controls
        };

        if (this.isEventEnabled('videoEnded'))
            config.onEnded = this.triggerEventIfEnabled.bind(this, 'videoEnded');

        this.player.open(config);
    };

    DynamicVideo.prototype.clearValue = function () {
        if (this.player)
            this.player.close();
    };

    DynamicVideo.prototype.afterShown = function () {
        if(this.url)
            this.openVideoPlayer();
    };

    DynamicVideo.prototype.afterHidden = function () {
        if (this.player)
            this.player.close();
    };

    return DynamicVideo;
});
